import { html, type TemplateResult } from 'lit';

// The MyBrainWorks brain glyph (figma pc3BggmcrbLZyey4vf62Q8, node 9:76):
// white left hemisphere, accent right hemisphere, and a neural network overlaid
// across both. Emitted as raw geometry so each consumer sizes and colours it
// through its OWN component-scoped classes — styles() may only target selectors
// namespaced under the owning component's block, so the parts are emitted as
// `${block}__brain*` and nothing leaks across components. Decorative: the
// visible wordmark alongside it carries the accessible name.
export function brainMark(block: string): TemplateResult {
  return html`
    <svg
      class="${block}__brain"
      viewBox="0 0 226.151 232.503"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        class="${block}__brain-half ${block}__brain-half--left"
        d="M109.077 20.5565V194.086C108.486 201.911 108.256 222.493 97.2376 228.002C87.1712 233.035 69.6708 237.243 60.6121 220.886C59.5839 219.029 47.6892 220.941 41.6495 215.908C35.6097 210.875 23.5006 199.252 26.7734 186.227C19.8069 186.227 10.9526 172.248 8.15071 162.58C3.62087 146.948 9.16662 134.962 8.15071 133.882C0.736324 126.001 -0.723089 109.761 0.283542 103.218C1.29017 96.6748 8.15071 91.5324 8.15071 84.486C8.15071 77.4395 5.2333 63.9072 19.8069 57.3115C19.8069 39.1072 25.7457 25.2735 41.6375 22.7844C45.1607 18.2301 47.3816 9.95605 57.4756 11.7912C60.723 12.3815 61.273 14.8995 61.1259 17.2698C63.0585 8.54135 69.7421 -3.36861e-06 86.1646 0C105.014 3.86631e-06 109.077 17.6328 109.077 20.5565Z"
      />
      <path
        class="${block}__brain-half ${block}__brain-half--right"
        d="M117.073 20.5565V194.086C117.664 201.912 117.895 222.493 128.913 228.002C138.979 233.035 156.48 237.243 165.538 220.886C166.567 219.029 178.461 220.941 184.501 215.908C190.541 210.875 202.65 199.252 199.377 186.227C206.344 186.227 215.198 172.248 218 162.58C222.53 146.948 216.984 134.962 218 133.882C225.414 126.001 226.874 109.761 225.867 103.218C224.86 96.6748 218 91.5324 218 84.486C218 77.4395 220.917 63.9072 206.344 57.3115C206.344 39.1072 200.405 25.2735 184.513 22.7844C180.99 18.2301 178.769 9.95606 168.675 11.7912C165.428 12.3815 164.878 14.8995 165.025 17.2698C163.092 8.54135 156.409 2.12922e-06 139.986 5.49783e-06C121.137 9.36414e-06 117.073 17.6328 117.073 20.5565Z"
      />
      <path
        class="${block}__brain-line"
        d="M157.111 66.1846H64.2983"
        stroke-width="5.31688"
        stroke-linejoin="round"
      />
      <path
        class="${block}__brain-line"
        d="M185.654 121.835L32.5749 121.965"
        stroke-width="5.31688"
        stroke-linejoin="round"
      />
      <path
        class="${block}__brain-line"
        d="M148.432 177.485H64.2983"
        stroke-width="5.31688"
        stroke-linejoin="round"
      />
      <circle class="${block}__brain-node" cx="64.2983" cy="66.1846" r="14.5013" />
      <circle class="${block}__brain-node" cx="182.971" cy="121.965" r="19.2525" />
      <circle class="${block}__brain-node" cx="162.16" cy="66.8691" r="9.45174" />
      <circle class="${block}__brain-node" cx="143.96" cy="177.665" r="10.7384" />
      <circle class="${block}__brain-node" cx="113.9" cy="122.267" r="11.592" />
      <circle class="${block}__brain-node" cx="64.2982" cy="121.835" r="11.592" />
      <circle class="${block}__brain-node" cx="32.5748" cy="121.965" r="6.7772" />
      <circle class="${block}__brain-node" cx="64.2982" cy="177.485" r="8.76883" />
      <path
        class="${block}__brain-line"
        d="M182.971 122.653L63.8477 66.8692V177.665L182.971 122.653Z"
        stroke-width="5.31688"
        stroke-linejoin="round"
      />
    </svg>
  `;
}
